import { useLanguage } from '../../lib/i18n/LanguageContext';
import { LanguageToggle } from '../ui/LanguageToggle';
import CardNav, { CardNavItem } from '../ui/CardNav';
import DarkModeToggle from '../ui/DarkModeToggle';

const Header = () => {
  const { t, isTransitioning } = useLanguage();

  const navItems: CardNavItem[] = [
    {
      label: t.common.nav.about,
      links: [
        {
          label: t.common.nav.aboutSub.ourStory,
          href: '/about',
          ariaLabel: 'Learn about our restaurant history and values',
        },
        {
          label: t.common.nav.aboutSub.joinTeam,
          href: '/careers',
          ariaLabel: 'View career opportunities at Rossopomodoro',
        },
      ],
    },
    {
      label: t.common.nav.menu,
      links: [
        {
          label: t.common.nav.menuSub.foodMenu,
          href: '/menu',
          ariaLabel: 'View our authentic Italian food menu',
        },
        {
          label: t.common.nav.menuSub.wineList,
          href: '/wine-list',
          ariaLabel: 'Explore our curated wine selection',
        },
      ],
    },
    {
      label: t.common.nav.contact,
      links: [
        {
          label: t.common.nav.contactSub.getInTouch,
          href: '/contact',
          ariaLabel: 'Contact us for inquiries and feedback',
        },
        {
          label: t.common.nav.contactSub.findUs,
          href: 'https://maps.app.goo.gl/iJ38nHTkanTaXeiS8',
          ariaLabel: 'View our location on Google Maps',
          external: true,
        },
      ],
    },
  ];

  return (
    <header className="fixed top-0 left-0 w-full z-50">
      {/* Hide CardNav completely on mobile/tablet. Keep desktop unchanged. */}
      <div className="hidden lg:block">
        <CardNav
          logo="https://oupvappnlmhqopqsewde.supabase.co/storage/v1/object/public/properties/rosso_1.png"
          logoAlt="Rossopomodoro Reykjavik - Authentic Italian Restaurant"
          items={navItems}
          ease="power3.out"
          ctaText={t.common.nav.reservations}
          onLogoClick={() => {
            window.location.href = '/';
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
          onCtaClick={() => {
            window.location.href = '/reservations';
          }}
          className={isTransitioning ? 'pointer-events-none opacity-70' : ''}
        >
          <LanguageToggle />
          <DarkModeToggle size="md" />
        </CardNav>
      </div>
    </header>
  );
};

export default Header;
